import { useEffect, useRef, useState } from "react";

const CLOSE_DELAY_MS = 100;

function popoverPosition(rect) {
    const width = Math.min(320, window.innerWidth - 32);
    const left = Math.max(16, Math.min(rect.left, window.innerWidth - width - 16));
    const placeBelow = window.innerHeight - rect.bottom >= 230 || rect.top < window.innerHeight / 2;
    return placeBelow
        ? { left, top: rect.bottom + 8, width }
        : { left, bottom: window.innerHeight - rect.top + 8, width };
}

// Infobulle des patients d'une commande : s'ouvre au survol, au focus ou au clic,
// se ferme 100 ms après la sortie sauf si la souris entre dans l'infobulle.
export function useSummaryPopover() {
    const [open, setOpen] = useState(false);
    const [position, setPosition] = useState(null);
    const anchorRef = useRef(null);
    const closeTimerRef = useRef(null);

    const cancelClose = () => {
        if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
    };
    const show = () => {
        cancelClose();
        const rect = anchorRef.current?.getBoundingClientRect();
        if (rect) setPosition(popoverPosition(rect));
        setOpen(true);
    };
    const scheduleClose = () => {
        cancelClose();
        closeTimerRef.current = setTimeout(() => setOpen(false), CLOSE_DELAY_MS);
    };
    const toggle = () => {
        if (open) setOpen(false);
        else show();
    };
    const hide = () => setOpen(false);

    useEffect(() => () => {
        if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    }, []);

    return { open, position, anchorRef, show, scheduleClose, cancelClose, toggle, hide };
}
